import { ObservabilityPipelineHttpMetricsOverview } from "Api/observability/pipeline/types";
import { BandWidthMetricsDataType } from "src/organization/pages/project/environment/metrics/http2/bandwidth/type";

export const getBandwidthMetrics = (
  httpMetrics: ObservabilityPipelineHttpMetricsOverview | null | undefined
): BandWidthMetricsDataType => {
  let totalBandwidth = 0;

  const bandwidths = (httpMetrics?.data?.timelines ?? []).map(timeline => {
    const bandwidthData = {
      request: 0,
      response: 0,
      totalBandWidth: 0
    };

    if (timeline.request_size && timeline.response_size) {
      bandwidthData.request = timeline.request_size;
      bandwidthData.response = timeline.response_size;
      bandwidthData.totalBandWidth =
        timeline.request_size + timeline.response_size;
      totalBandwidth += timeline.request_size + timeline.response_size;
    }
    return {
      ...bandwidthData,
      date: new Date(timeline.timestamp * 1000),
      timestamp: timeline.timestamp
    };
  });

  return { data: bandwidths, totalBandwidth };
};

export const bandwidthColorBand = {
  request: "#AE82FF",
  response: "#653193"
};

export const bandwidthOption = ["request", "response"];
